<template>
    <h1>This widget has no visual implementation</h1>
</template>

<script>
    import Vue from 'vue';
    import {Component, Prop, Watch, Model} from 'vue-property-decorator';
    import {formatQuery} from '../../api/format-query';
    import axios from 'axios';

    @Component
    export default class DashboardWidget extends Vue {
        @Prop({
            type: Object,
            default: () => ({
                daterange: {
                    start: new Date(),
                    end: new Date()
                },
                filters: {
                    recruiter: [],
                    company: [],
                    branch: [],
                    subbranch: []
                }
            })
        })
        query;

        @Model('widgetData', {
            type: Object,
            default: () => ({})
        })
        widgetData;

        api = {
            endpoint: null,
            loading: null,
            error: false,
            loadingMessage: null,
            errorMessage: null,
            cancel: null,
            allow404: false,
        };

        @Watch('query', {deep: true})
        onQueryChanged() {
            if (this.shouldRequestData()) {
                this.requestData();
            }
        }

        requestData() {
            // If the cancellation token exists, cancel the ongoing request
            if (this.api.cancel) {
                this.api.cancel.cancel('Rapid re-request');
            }
            this.api.loading = true;
            this.api.error = false;
            this.api.cancel = axios.CancelToken.source();// Create cancellation token for the new request, used by requestOptions getter
            // Create query promise and setup continuations
            return this.createQuery()
                .then(response => this.onQueryData(response))
                .then(() => this.api.error = false)
                .catch(error => {
                    const isCancel = (error && error.message === 'Rapid re-request');
                    if (!isCancel) {
                        this.api.error = true;
                        return this.onQueryError(error);
                    }
                })
                .finally(() => this.api.cancel = null)
                .finally(() => this.api.loading = false);
        }

        shouldRequestData() {
            return this.api.endpoint;
        }

        createQuery() {
            return this.axios.post(this.api.endpoint, this.requestParams, this.requestOptions);
        }

        get requestParams() {
            return formatQuery(this.query);
        }

        get requestOptions() {
            return {
                cancelToken: this.api.cancel.token,
            };
        }

        onQueryData(response) {
        }

        onQueryError(error) {
            console.error('[ DashboardWidget ]', 'QueryError', error.response);
            const translateStatus = {
                [404]: 'widgets.error_not_found',
                [429]: 'widgets.error_rate_limit',
            };
            const status = error.response && error.response.status;
            if (this.api.allow404 && status === 404) {
                this.api.error = false;
                return this.onQueryData(null);
            } else {
                const translation = this.$t(translateStatus[status] || 'widgets.error_general');
                return this.showError(translation);
            }
        }

        showError(message) {
            this.api.errorMessage = message;
            this.$notify.error(message);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/DashboardWidget.vue